import { inject, Injectable, Optional } from '@angular/core';
import { DatasourceTableJobHttpModel, DatasourceTableJobService } from '@y42/datasource';
import { ErrorHandlerService } from '@y42/error-handling';
import { getY42GitPath, Y42GitFolders } from '@y42/feature/git';
import { Y42RouterService, Y42Routes } from '@y42/feature/routing';
import { GitQuery } from '@y42/git';
import { AbstractJobCancelationService, JobContextService, JobHttpService, JobTriggerService } from '@y42/job';
import { OrgQuery } from '@y42/org/state';
import { Y42FeatureType } from '@y42/json-schema';
import { UiModelingTableStore } from '../../state/datasource-table';
import { UiModelingTableJobQuery, UiModelingTableJobStore } from '../../state/datasource-table-job';
import { UiModelingStoreQuery } from '../../state/datasource/ui-modeling.store-query';

@Injectable({ providedIn: 'root' })
export class UiModelingTableJobService extends DatasourceTableJobService {
  constructor(
    triggerService: JobTriggerService,
    parentStore: UiModelingTableStore,
    jobStore: UiModelingTableJobStore,
    jobQuery: UiModelingTableJobQuery,
    jobContext: JobContextService,
    gitQuery: GitQuery,
    errorHandlerService: ErrorHandlerService,
    jobHttpService: JobHttpService<DatasourceTableJobHttpModel>,
    orgQuery: OrgQuery,
    @Optional() jobCancelationService?: AbstractJobCancelationService,
  ) {
    super(
      triggerService,
      parentStore,
      jobStore,
      jobQuery,
      jobContext,
      gitQuery,
      errorHandlerService,
      jobHttpService,
      getY42GitPath(Y42GitFolders.UiModel),
      Y42Routes.UiModeling,
      inject(Y42RouterService),
      inject(UiModelingStoreQuery).selectLoading(),
      inject(UiModelingStoreQuery).selectActiveId(),
      jobCancelationService,
    );
  }

  readonly defaultFeatureGitPath = getY42GitPath(Y42GitFolders.UiModel);
  readonly featureType = Y42FeatureType.UiModel;
}
